import { createGlobalStyle } from 'styled-components';

export const CSSBaseline = createGlobalStyle`
    #root > #transition-group {
        height: 100%;
        width: 100%;
    }
    @media screen and (max-device-width: 480px){
        body {
            text-size-adjust: 100%;
        }
    }
`;
